import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { DocLink, DocPages } from 'components/Help';
import { Empty, Icon, Spin } from 'antd';
import { Table } from 'components/Page';
import { connect } from 'react-redux';
import { list } from 'actions';
import config from './config';

const mapDispatchToProps = dispatch => ({
  loadTheme(themeName) {
    const page = 0;
    const pageSize = 1;
    const filters = [{
      id: 'model',
      value: themeName
    }];
    const sorted = [{
      id: 'model',
      desc: false
    }];

    return dispatch(list(
      REDUCER_KEY.objectHistoryThemes.key, {
        page,
        pageSize,
        filters,
        sorted
      }
    ));
  }
});

const mapStateToProps = state => ({
  themes: state.api.objectHistoryThemes.data.results,
  inFlight: state.api.objectHistory.inFlight || state.api.objectHistoryThemes.inFlight
});

const AuditHistory = ({
  inFlight, objectId, themeName, loadTheme, themes
}) => {
  useEffect(() => {
    loadTheme(themeName);
  }, []);

  if (!themes.length) {
    return (
      <div className="bhp-container">
        <Spin indicator={<Icon type="loading" spin />} tip="Loading..." spinning={inFlight}>
          <Empty
            image="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
            description={`No history for this ${themeName}`}
          />
        </Spin>
      </div>
    );
  }

  return (
    <Table
      reducer={{
        item: REDUCER_KEY.objectHistory,
        list: REDUCER_KEY.objectHistory
      }}
      config={{
        ...config,
        filters: {
          object_id: [objectId],
          theme_id: themes.length ? [themes[0].id] : [-1]
        },
        title: <DocLink page={DocPages.history}>History</DocLink>
      }}
    />
  );
};

AuditHistory.propTypes = {
  objectId: PropTypes.number.isRequired,
  themeName: PropTypes.string.isRequired,
  inFlight: PropTypes.bool,
  loadTheme: PropTypes.func,
  themes: PropTypes.array
};

AuditHistory.defaultProps = {
  inFlight: false,
  loadTheme: () => {
  },
  themes: []
};

export default connect(mapStateToProps, mapDispatchToProps)(AuditHistory);
